export default function saveParentChildNodes ({
    db, 
    settingParentQ, 
    thisNodeId, 
    thisNodeData, 
    reciprocalNodeId, 
    reciprocalNodeData, 
    successFunc, 
    errorFunc
  }) {
  const batch = db.batch()
  const thisNodeRef = db.collection('knowledgeMapNodes').doc(thisNodeId)
  
  settingParentQ === true
    ? batch.set(thisNodeRef, {
        parents: thisNodeData,
      }, {merge: true})
    : batch.set(thisNodeRef, {
        children: thisNodeData,
      }, {merge: true})


  const reciprocalNodeRef = db.collection('knowledgeMapNodes').doc(reciprocalNodeId)

  settingParentQ === true
    ? batch.set(reciprocalNodeRef, {
        children: reciprocalNodeData,
      }, {merge: true})
    : batch.set(reciprocalNodeRef, {
        parents: reciprocalNodeData,
      }, {merge: true})
  
  batch.commit()
    .then(() => successFunc())
    .catch((error) => errorFunc(error))
}


// WEBPACK FOOTER //
// ./src/helpers/saveParentChildNodes.js